import { SVGProps, Ref, forwardRef } from "react";

const MenuIcon = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Menu Icon"
    {...props}
  >
    <title id="Menu Icon">Menu Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 12h18M3 6h18M3 18h18"
    />
  </svg>
);

const ForwardRef = forwardRef(MenuIcon);
export default ForwardRef;
